import { render, staticRenderFns } from "./registroPostulacion.vue?vue&type=template&id=c457781a&scoped=true&"
import script from "./registroPostulacion.vue?vue&type=script&lang=js&"
export * from "./registroPostulacion.vue?vue&type=script&lang=js&"
import style0 from "./registroPostulacion.vue?vue&type=style&index=0&id=c457781a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c457781a",
  null
  
)

export default component.exports